const messages = {
  etax: {
    loadingTitle: 'Verifying information...',
    loadingDesc: 'Please wait',

    title: 'Tax Invoice Details',

    issuedTitle: 'Tax invoice issued',
    issuedDesc: 'The file can be downloaded within 7 days after issuance',

    success: 'Success',

    fileName: 'File name',
    issueDate: 'Issue date',
    expireDate: 'Download expiry date',

    download: 'Download PDF',
    expired: 'Download link expired',

    createTitle: 'Create tax invoice',
    editTitle: 'Edit tax invoice information',

    unexpectedError: 'Unexpected error occurred'
  }
}
export default messages